var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyIconFig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#5FBDD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2939 11.7647V39.7059",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2939 11.7647L16.1763 8.82355",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2939 39.7059L16.1763 41.1765",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 39.1765V10.8235C14.7061 9.71898 15.6015 8.82355 16.7061 8.82355H36.2355C37.34 8.82355 38.2355 9.71898 38.2355 10.8235V39.1765C38.2355 40.2811 37.34 41.1765 36.2355 41.1765H16.7061C15.6015 41.1765 14.7061 40.2811 14.7061 39.1765Z",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 16.1765H33.8231",
    stroke: "#F7FDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 29.4118H26.4701",
    stroke: "#F7FDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 25H33.8231",
    stroke: "#F7FDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 20.5883H33.8231",
    stroke: "#F7FDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIconFig);
export default __webpack_public_path__ + "static/media/StudyIconFig.a6b23885244bcd259179240e764ac3c8.svg";
export { ForwardRef as ReactComponent };